import { userService } from '@saucelabs/sl-util-axios';

export const moveTeamUsers = ({ from, to }) => {
  const data = {
    from_team_id: from,
    to_team_id: to,
  };
  return userService.patch('/v1/teams/', data);
};
